export const shouldFetchUser = (state, id) => {
  if (state.users.users_loading[id]) {
    return false;
  }
  return !(id in state.users.users);
};

export const loadingInitialUsersList = state => {
  return state.users.loading && Object.keys(state.users.users).length === 0;
};

export const getUserWithId = (state, id) => {
  const users = state.users.users;
  return users[id] ? users[id] : undefined;
};

//TODO: if necessary change reducer to support individual loader for every user
export const isUpdatingUser = (state, id) => {
  return state.users.loading;
};

export const isActivatedUser = (state, id) => {
  const user = getUserWithId(state, id);
  if (user && user.roles.includes("active-user")) {
    return true;
  } else {
    return false;
  }
};

export const isSuperUser = (state, id) => {

  const user = getUserWithId(state, id);
  if (user && user.roles.includes("super-user")) {
    return true;
  } else {
    return false;
  }
};